import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchExternalBookings } from '../../ducks/externalBookings.duck';
import { PROVIDER } from '../../util/types';
import { transitions } from '../../transactions/transactionProcessBooking';
import { transitions as transitionOffsession } from '../../transactions/transactionProcessOffsession';
import moment from 'moment';
const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );

// ================ Action types ================ //

export const FETCH_ORDERS_OR_SALES_REQUEST = 'app/OnholdLisitngsPage/FETCH_ORDERS_OR_SALES_REQUEST';
export const FETCH_ORDERS_OR_SALES_SUCCESS = 'app/OnholdLisitngsPage/FETCH_ORDERS_OR_SALES_SUCCESS';
export const FETCH_ORDERS_OR_SALES_ERROR = 'app/OnholdLisitngsPage/FETCH_ORDERS_OR_SALES_ERROR';

// ================ Reducer ================ //

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchOrdersOrSalesError: null,
  pagination: null,
  transactionRefs: [],
};

export default function inboxPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ORDERS_OR_SALES_REQUEST:
      return { ...state, fetchInProgress: true, fetchOrdersOrSalesError: null };
    case FETCH_ORDERS_OR_SALES_SUCCESS: {
      const transactions = sortedTransactions(payload.data.data);
      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_ORDERS_OR_SALES_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchOrdersOrSalesError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchOrdersOrSalesRequest = () => ({ type: FETCH_ORDERS_OR_SALES_REQUEST });
const fetchOrdersOrSalesSuccess = response => ({
  type: FETCH_ORDERS_OR_SALES_SUCCESS,
  payload: response,
});
const fetchOrdersOrSalesError = e => ({
  type: FETCH_ORDERS_OR_SALES_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

const INBOX_PAGE_SIZE = 100;

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const { tab = 'sales' } = params;

  const state = getState();
  const user = state.user.currentUser;
  const userType = user && user.id && user.attributes.profile.publicData.userType;
  const isProvider = userType == PROVIDER;

  const onlyFilterValues = {
    orders: 'order',
    sales: 'sale',
  };

  const requiredTab = isProvider ? 'sales' : 'orders';

  const onlyFilter = onlyFilterValues[requiredTab];
  if (!onlyFilter) {
    return Promise.reject(new Error(`Invalid tab for InboxPage: ${tab}`));
  }

  dispatch(fetchOrdersOrSalesRequest());

  const { page = 1 } = parse(search);

  // Pending external offers are listed here too. Fire-and-forget: the thunk
  // swallows its own errors, so a missing database can't break this page.
  dispatch(fetchExternalBookings());

  const apiQueryParams = {
    // only: onlyFilter,
    // lastTransitions: getAllTransitionsForEveryProcess(),
    lastTransitions: [transitions.CONFIRM_PAYMENT, transitionOffsession.REQUEST_BOOKING],
    include: [
      'listing',
      'provider',
      'provider.profileImage',
      'customer',
      'customer.profileImage',
      'booking',
    ],
    'fields.transaction': [
      'processName',
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'payinTotal',
      'payoutTotal',
      'lineItems',
      // Needed for the "Reserva externa" badge; this list was the one place that
      // never asked for it.
      'metadata',
      // `bookingFace`, para el título de la cara reservada.
      'protectedData',
    ],
    'fields.listing': [
      'title',
      'availabilityPlan',
      'publicData.listingType',
      // Para mostrar el título de la cara reservada (`bookedFaceView`).
      'publicData.gardenTitle',
      'publicData.searchListingType',
      'publicData.category',
    ],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
    sort: '-bookingStart',
    // bookingStart: `${moment()
    //   .subtract(1, 'day')
    //   .toISOString()},`,
    page,
    perPage: INBOX_PAGE_SIZE,
  };

  return sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchOrdersOrSalesSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchOrdersOrSalesError(storableError(e)));
      throw e;
    });
};
